import React, {Component} from 'react';

export default class OrangeSVG extends Component {

render() {
  return(
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
   viewBox="0 0 1500 1500">
<path className="st3" d="M1325,1403H175c-46.8,0-85-38.3-85-85V168c0-46.8,38.3-85,85-85h1150c46.8,0,85,38.3,85,85v1150
  C1410,1364.8,1369.8,1403,1325,1403z"/>
<path className="st4" d="M353.7,83v985c0,56.7,46,102.7,102.7,102.7S559,1124.7,559,1068V83H353.7z"/>
<path className="st4" d="M744.3,397.3c-56.7,0-102.7,46-102.7,102.7v568c0,56.7,46,102.7,102.7,102.7S847,1124.7,847,1068V500
  C847,443.3,801,397.3,744.3,397.3z"/>
<path className="st4" d="M1028.3,397.3c-56.7,0-102.7,46-102.7,102.7v568c0,56.7,46,102.7,102.7,102.7s102.7-46,102.7-102.7V500
  C1131,443.3,1085,397.3,1028.3,397.3z"/>
</svg>
    )}
}

